import { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { Box, Flex, Text, Button, Spinner } from "@chakra-ui/react";
import { ArrowLeft } from "lucide-react";
import { supabase } from "@/lib/supabaseClient";
import Setup from "@/pages/Setup";
import { colors } from "@/theme/colors";

// White-glove onboarding: Super-Admin runs the same Locations & Employees
// setup the company's Org Admin uses, scoped to that company's tenant.
export default function PlatformCompanySetup() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.from("companies").select("id,name").eq("id", id).single()
      .then(({ data }) => { setCompany(data); setLoading(false); });
  }, [id]);

  if (loading) return <Flex minH="40vh" align="center" justify="center"><Spinner color={colors.teal} borderWidth="3px" /></Flex>;

  return (
    <Box data-testid="platform-company-setup">
      <Button variant="ghost" size="sm" mb="2" onClick={() => navigate(`/platform/company/${id}`)} data-testid="back-to-company">
        <ArrowLeft size={15} /> Back to {company?.name || "company"}
      </Button>
      <Box mb="4" px="4" py="2.5" borderRadius="10px" bg={colors.tealTint} border="1px solid" borderColor="#BFE3E8" data-testid="whiteglove-banner">
        <Text fontSize="sm" color={colors.textPrimary}>
          White-glove setup — you are acting on behalf of <b>{company?.name}</b>. Everything you create here belongs to their tenant, exactly as if their Org Admin entered it.
        </Text>
      </Box>
      <Setup overrideCompanyId={id} overrideCompanyName={company?.name} initialTab={params.get("tab") || "locations"} />
    </Box>
  );
}
